import React from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Strong } from '../../../components/atoms/Strong/Strong';

type Hint = {
  hint?: string;
  message: string;
};

export function Hint({ hint, message }: Hint) {
  const { t } = useSonTranslation('glossary');
  return (
    <p className="hint">
      <Strong>{hint || t('instruction')}: </Strong>
      {message}
    </p>
  );
}
